// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"XD-z","expressButtonContainerWithPayPal":"YD-z","expressButton":"ZD-z","or":"_D-z"};